import Router from 'vue-router'
import goTo from '../node_modules/vuetify/es5/services/goto'
// Vuex
import store from './store.js';

// const HelloWorld = () => import('./components/HelloWorld.vue')
// const Test = () => import('./components/Test.vue')
// const Home = () => import('./components/Home.vue')
const Page403 = () => import('./components/Page403.vue')
const Page404 = () => import('./components/Page404.vue')
const reportDownloads = () => import('./components/reportDownloads/Index.vue')
const materialSales = () => import('./components/materialSales/Index.vue')
const materialSalesDetail = () => import('./components/materialSales/Detail.vue')
const materialDailySaleCount = () => import('./components/materialDailySaleCount/Index.vue')
const shopSales = () => import('./components/shopSales/Index.vue')
const distributionShopAnalyze = () => import('./components/distributionShopAnalyze/Index.vue')
const distributionShopAnalyzeDetail = () => import('./components/distributionShopAnalyze/Detail.vue')
const shopSalesDetail = () => import('./components/shopSales/Detail.vue')
const SubAccountAnalyses = () => import('./components/subAccountAnalyses/Index.vue')
const SubAccountAnalysesDetail = () => import('./components/subAccountAnalyses/Detail.vue')
const SubAccountAnalysesSplit = () => import('./components/subAccountAnalyses/SplitDetail.vue')
const DistributionMaterialAnalyze = () => import('./components/distributionMaterialAnalyze/Index.vue')
const MaterialAnalyzeDetail = () => import('./components/distributionMaterialAnalyze/Detail.vue')
const ExamineMaterialAnalyze = () => import('./components/examineMaterialAnalyze/Index.vue')
const ExamineMaterialAnalyzeDetail = () => import('./components/examineMaterialAnalyze/Detail.vue')
const OrderProfit = () => import('./components/orderProfit/Index.vue')
const OrderProfitDetail = () => import('./components/orderProfit/Detail.vue')
const ShopProfit = () => import('./components/shopProfit/Index.vue')
const ShopProfitDetail = () => import('./components/shopProfit/Detail.vue')
// const ShopCost = () => import('./components/shopCost/Index.vue')
// const MaterialCost = () => import('./components/materialCost/Index.vue')
const MaterialProfit = () => import('./components/MaterialProfit/Index.vue')
const shopDailyReports = () => import('./components/shopDailyReports/Index.vue')
const shopDailyReportsDetail = () => import('./components/shopDailyReports/Detail.vue')
const subAccountOrders = () => import('./components/subAccountOrders/Index.vue')//分账结算查询
const subAccountOrdersDetail = () => import('./components/subAccountOrders/Detail.vue')//分账结算查询
const shopSubAccountSum = () => import('./components/shopSubAccountSum/Index.vue')
const shopSubAccountSumDetail = () => import('./components/shopSubAccountSum/Detail.vue')
const allianceSubAccounts = () => import('./components/allianceSubAccounts/Index.vue')
const allianceSubAccountDetails = () => import('./components/allianceSubAccounts/Detail.vue')
const MonthlyStatisticss = () => import('./components/monthlyStatisticss/Index.vue')
const MonthlyStatisticssDetail = () => import('./components/monthlyStatisticss/Detail.vue')
const ShopCostAnalyze = () => import('./components/shopCostAnalyze/Index.vue')
const ShopCostAnalyzeDetail = () => import('./components/shopCostAnalyze/Detail.vue')
const ShopCostAnalyzeShops = () => import('./components/shopCostAnalyze/Shops.vue')

const MaterialCostAnalyze = () => import('./components/materialCostAnalyze/Index.vue')
const OrderBacklog = () => import('./components/orderBacklog/Index.vue')
const BillProfit = () => import('./components/billProfit/Index.vue')
const BillProfitDetail = () => import('./components/billProfit/Detail.vue')

const orderFreight = () => import('./components/orderFreight/Index.vue')
const orderService = () => import('./components/orderService/Index.vue')
const orderServiceDetail = () => import('./components/orderService/Detail.vue')
const orderCategoryFreight = () => import('./components/orderCategoryFreight/Index.vue')
const orderCategoryFreightDetail = () => import('./components/orderCategoryFreight/Detail.vue')

var router = new Router({
    routes: [
        { path: '/', component: reportDownloads },//首页
        { path: '/home', component: reportDownloads },//首页
        { path: '/from-happylike/:from/:access_token', component: reportDownloads },//首页，接受后台跳转
        { path: '/from-happylike/:from/:access_token/:redirect', component: reportDownloads },//首页，接受后台跳转
        // { path: '/test', component: Test },//！测试页，发布时要拿掉
        { path: '/page404', component: Page404 },//Page404
        { path: '/page403', component: Page403 },//Page404
        { path: '/material-sales', component: materialSales },//商品销量统计
        { path: '/material-sales/:material_id', component: materialSalesDetail },//商品销量统计区域明细
        { path: '/material-daily-sale', component: materialDailySaleCount },//商品日销量汇总统计
        { path: '/shop-sales', component: shopSales },//门店销售统计
        { path: '/shop-sales/:shop_id', component: shopSalesDetail },//门店销售明细
        { path: '/sub-account-analyses', component: SubAccountAnalyses },//分账结算汇总
        { path: '/sub-account-analyses/:sub_account_id', component: SubAccountAnalysesDetail },//分账结算明细
        { path: '/sub-account-split/:sub_account_id', component: SubAccountAnalysesSplit },//分账结算提现
        { path: '/distribution-material-analyze', component: DistributionMaterialAnalyze },//商品配送统计
        { path: '/distribution-material-analyze/by-district-detail/:id', component: MaterialAnalyzeDetail },//商品配送统计明细
        { path: '/examine-material-analyze', component: ExamineMaterialAnalyze },//商品验收统计
        { path: '/examine-material-analyze/by-district-detail/:id', component: ExamineMaterialAnalyzeDetail },//商品验收统计明细
        { path: '/order-profit', component: OrderProfit },// 毛利分析统计
        { path: '/order-profit/order-profit-detail/:code', component: OrderProfitDetail },// 毛利分析统计详情
        { path: '/shop-profit', component: ShopProfit },// 门店毛利分析统计
        { path: '/shop-profit/detail/:id', component: ShopProfitDetail },// 门店毛利分析统计明细
        // { path: '/shop-cost', component: ShopCost },// 门店成本分析统计
        // { path: '/material-cost', component: MaterialCost },// 货品损耗分析统计
        { path: '/material-profit', component: MaterialProfit }, // 商品毛利分析
        { path: '/shop-daily-reports', component: shopDailyReports }, // 门店销售营业统计
        { path: '/shop-daily-reports/:id', component: shopDailyReportsDetail }, // 门店销售营业统计详情
        { path: '/sub-account-orders', component: subAccountOrders },//分账结算查询
        { path: '/sub-account-orders/:id', component: subAccountOrdersDetail },//分账结算查询明细
        { path: '/shop-sub-account-sum', component: shopSubAccountSum},//门店分账汇总
        { path: '/shop-sub-account-sum/detail', component: shopSubAccountSumDetail},//门店分账明细
        { path: '/alliance-sub-accounts', component: allianceSubAccounts},//门店销售分账
        { path: '/alliance-sub-accounts/detail', component: allianceSubAccountDetails},//门店销售分账
        { path: '/distribution-shop-analyze', component: distributionShopAnalyze },//门店配送统计
        { path: '/distribution-shop-analyze/detail', component: distributionShopAnalyzeDetail },//门店配送详情
        { path: '/monthly-statisticss', component: MonthlyStatisticss },//月度统计
        { path: '/monthly-statisticss/:shop_id', component: MonthlyStatisticssDetail },//月度统计
        { path: '/shop-cost-analyze', component: ShopCostAnalyze }, // 门店成本月度分析
        { path: '/shop-cost-analyze/:id', component: ShopCostAnalyzeDetail }, // 门店成本月度分析
        { path: '/shop-cost-analyze/detail/push-to-shop', component: ShopCostAnalyzeShops }, // 门店成本月度分析选择门店
        { path: '/material-cost-analyze', component: MaterialCostAnalyze }, // 货品损耗成本分析
        { path: '/order-backlog', component: OrderBacklog}, // 未订货统计
        { path: '/bill-profit', component:BillProfit}, // 账单成本分析
        { path: '/bill-profit/bill-profit-detail/:id', component: BillProfitDetail },// 账单分析统计详情
        { path: '/order-freight', component: orderFreight }, // 订单运费统计
        { path: '/order-service', component: orderService }, // 订单服务费统计
        { path: '/order-service/:bill_code', component: orderServiceDetail }, // 账单服务费明细
        { path: '/order-category-freight', component: orderCategoryFreight}, // 订单分类运费统计
        { path: '/order-category-freight/:id', component: orderCategoryFreightDetail}, // 订单分类运费统计明细


        { path: '*', component: Page404 }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
})

router.beforeEach((to, from, next) => {
    store.commit("searchDistrict", false);// 导航切换时默认关闭侧边栏的门店分组搜索控件
    next();
})

export default router